import {inject, Injectable} from '@angular/core';
import {DsToastService, DsToastTone} from '@bmw-ds/components';
import {UuidUtil} from '@service-and-repairs/dms-impl';

@Injectable({
  providedIn: 'root'
})
export class NotificationsService {
  private readonly toastService: DsToastService = inject(DsToastService);

  private static getNotificationTimeoutInMs(message: string): number {
    // https://ux.stackexchange.com/questions/11203/how-long-should-a-temporary-notification-toast-appear
    return Math.min(Math.max(message.length * 100, 3000), 20000);
  }

  showErrorNotification(message: string, origin?: string): void {
    this.showNotification(message, 'critical', undefined, origin);
  }

  showWarningNotification(message: string, origin?: string): void {
    this.showNotification(message, 'caution', undefined, origin);
  }

  showSuccessNotification(message: string, origin?: string): void {
    this.showNotification(message, 'positive', undefined, origin);
  }

  showInfoNotification(message: string, duration?: number, origin?: string): void {
    this.showNotification(message, 'info', duration, origin);
  }

  private static readonly ORIGIN_LABEL_OVERRIDES: Record<string, string> = {
    SERVER: 'AWP',
    PRO_NET: 'ProNET'
  };

  private formatOriginLabel(origin: string): string {
    if (NotificationsService.ORIGIN_LABEL_OVERRIDES[origin]) {
      return NotificationsService.ORIGIN_LABEL_OVERRIDES[origin];
    }
    const lowerWithSpaces: string = origin.replace(/_/g, ' ').toLowerCase();
    return lowerWithSpaces.charAt(0).toUpperCase() + lowerWithSpaces.substring(1);
  }

  private showNotification(message: string, tone: DsToastTone, duration?: number, origin?: string): void {
    const label: string = origin ? this.formatOriginLabel(origin) : 'anonymous';
    console.debug(`[AWP Notification] [${tone}] [origin: ${label}] ${message}`);
    this.toastService.pushToast({
      tone: tone,
      toastText: message,
      toastTitle: origin ? this.formatOriginLabel(origin) : undefined,
      duration: duration ?? NotificationsService.getNotificationTimeoutInMs(message),
      id: UuidUtil.generateUuid()
    });
  }
}
